import { getTheme, Shimmer, ShimmerElementType } from '@fluentui/react';
import React, { useLayoutEffect, useRef, useState } from 'react';

const STAGE_PADDING = 32;

/**
 * One large area-card-style shimmer block (same Shimmer line pattern as AreaDirectorySkeleton),
 * scaled to the main column instead of many small boxes.
 */
const JitsiCallSurfaceSkeleton: React.FC = () => {
    const theme = getTheme();
    const containerRef = useRef<HTMLDivElement>(null);
    const [blockHeight, setBlockHeight] = useState(320);

    useLayoutEffect(() => {
        const el = containerRef.current;
        if (!el || typeof ResizeObserver === 'undefined') {
            return;
        }
        const update = () => {
            const { width, height } = el.getBoundingClientRect();
            const pad = STAGE_PADDING * 2;
            const innerH = Math.max(0, height - pad);
            const innerW = Math.max(0, width - pad);
            const h = Math.max(160, Math.min(Math.floor(innerH * 0.72), Math.floor(innerW * 0.85), 640));
            setBlockHeight(h);
        };
        update();
        const ro = new ResizeObserver(() => update());
        ro.observe(el);
        return () => ro.disconnect();
    }, []);

    return (
        <div
            ref={containerRef}
            style={{
                width: '100%',
                height: '100%',
                minHeight: 200,
                boxSizing: 'border-box',
                padding: STAGE_PADDING,
                backgroundColor: theme.palette.white,
                borderRadius: '4px 4px 0 0',
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}
            aria-busy
            aria-label="Loading"
        >
            <div style={{ width: '100%' }}>
                <Shimmer width="100%" shimmerElements={[{ type: ShimmerElementType.line, height: blockHeight, width: '100%' }]} />
            </div>
        </div>
    );
};

export default JitsiCallSurfaceSkeleton;
